import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import Title from '../../../components/common/title';
import { WAREHOUSE_PRODUCTS_INDEX } from '../../../router/routes';
import ProductsList from './list';
import { ProductObtainType } from '../../../enums/product-obtain-type';

export default function Products() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(WAREHOUSE_PRODUCTS_INDEX, [
    'obtainTypeId',
    'farmId',
  ]);

  return (
    <>
      <Title title={t('pages.warehouse.products.title')} />
      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <TabLink tabKey={ProductObtainType.PRODUCED}>
              {t('pages.warehouse.products.types.produced')}
            </TabLink>
            <TabLink tabKey={ProductObtainType.PURCHASED}>
              {t('pages.warehouse.products.types.purchased')}
            </TabLink>
            <TabLink tabKey={ProductObtainType.RECYCLE_GAINED}>
              {t('pages.warehouse.products.types.recycle_gained')}
            </TabLink>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <Tab tabKey={ProductObtainType.PRODUCED}>
              <ProductsList />
            </Tab>
            <Tab tabKey={ProductObtainType.PURCHASED}>
              <ProductsList />
            </Tab>
            <Tab tabKey={ProductObtainType.RECYCLE_GAINED}>
              <ProductsList />
            </Tab>
          </TabContents>
        }
      />
    </>
  );
}
